<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px;margin-top: 70px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/找回密码</span></div>
		<div style="width: 367px;margin: 100px auto;">
			<el-form status-icon label-width="100px" class="demo-ruleForm">
				<el-form-item label="用户名"><el-input v-model="ruleForm.email" placeholder="请输入用户名"></el-input></el-form-item>
				<el-form-item>	
					<el-button type="primary" @click="submitForm">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import { forgetP } from '../api/service'

export default {
	data() {
		return {
			ruleForm: {
				email: ''
			}
		};
	},
	methods: {
		submitForm() {
			const params = {
				email: this.ruleForm.email
			}
			forgetP(params).then(response => {
				if (response.data.success === true) {
                    this.$alert('新密码已发送至登录Email', '提示', {
						confirmButtonText: '确定'
					})
					this.$router.push({
						path: '/signin'
					});
				} else {
					this.$alert('找回密码失败', '提示', {
						confirmButtonText: '确定'
					})
				}
			}).catch(() => {
				this.$message({ type: 'warning', message: '找回密码失败!' })
			})
		}
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
li {
	list-style: none;
}
a {
	text-decoration: none;
}
.meorder-li li {
	display: inline-block;
	margin: 7px 17px 0 30px;
	font-size: 12px;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
</style>
